import React from "react";
import "../Css/style.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const toolbarOptions = [
  [{ header: [1, 2, 3, false] }], // Headings
  ["bold", "italic", "underline", "strike"], // Text styles
  [{ list: "ordered" }, { list: "bullet" }], // Lists
  [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
  [{ indent: "-1" }, { indent: "+1" }], // Indentation
  [{ align: [] }], // Text alignment
  ["blockquote", "code-block"], // Blockquote and code
  //   ["link", "image"], // Link and Image support
  ["clean"], // Remove formatting
];

// function RichTextForm({ labelName, value, onchange }) {
//   const quillRef = useRef(null); // Reference to the Quill editor

//   const handleSaveContent = () => {
//     if (quillRef.current) {
//       const htmlContent = quillRef.current.getEditor().root.innerHTML; // Get the raw HTML content
//       onchange(htmlContent); // Pass the content to parent
//     }
//   };

//   return (
//     <div className=" ">
//       <label className="my-2">{labelName}</label>
//       <ReactQuill
//         ref={quillRef} // Assign the ref to ReactQuill
//         theme="snow"
//         value={value || ""} // Ensuring the value is not undefined
//         onChange={handleSaveContent} // Use the handleSaveContent function
//         className=" mb-5"
//         modules={{ toolbar: toolbarOptions }} // Adding custom toolbar
//       />
//     </div>
//   );
// }
function RichTextForm({ labelName, value, onchange }) {
  return (
    <div className=" ">
      <label className="my-2">{labelName}</label>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onchange} // This will provide full HTML automatically
        className=" mb-5"
        modules={{ toolbar: toolbarOptions }}
      />
    </div>
  );
}

export default RichTextForm;
// import React from "react";
// import { Editor } from "@tinymce/tinymce-react";
// import "../Css/style.css";

// const RichTextForm = ({ labelName, value, onchange }) => {
//   const handleEditorChange = (content, editor) => {
//     onchange(content); // Pass the updated content to parent
//   };

//   return (
//     <div className="rich-text-form">
//       <label className="my-2">{labelName}</label>
//       <Editor
//         value={value}
//         init={{
//           height: 400,
//           menubar: true,
//           plugins: [
//             "advlist",
//             "autolink",
//             "lists",
//             "link",
//             "image",
//             "charmap",
//             "print",
//             "preview",
//             "searchreplace",
//             "wordcount",
//           ],
//           toolbar:
//             "undo redo | formatselect | bold italic underline | bullist numlist | link image | preview",
//           // Remove apiKey to avoid the request for the key
//         }}
//         onEditorChange={handleEditorChange}
//       />
//     </div>
//   );
// };

// export default RichTextForm;
